<template>
	<div class>
    <el-dialog
			title="销假申请"
			:visible.sync="addEditShow"
			width="50%"
			:before-close="handleChangeDrawer"
		>
				<div class="pay-mains">
					<el-form
						ref="form"
						class="mobile-ruleForm card-ruleForm"
						label-width="114px"
						label-position="left"
					>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="staffName"
                  label="店员姓名"
                  prop="staffName"
                >
                  {{ form.staffName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="leaveCateId"
                  label="请假类型"
                  prop="leaveCateId"
                >
                  {{ form.leaveCateName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="beginTime"
                  label="开始时间"
                  prop="beginTime"
                >
                  <el-date-picker
                    v-model="form.beginTime"
                    type="date"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @change="startTime"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="endTime"
                  label="结束时间"
                  prop="endTime"
                >
                  <el-date-picker
                    v-model="form.endTime"
                    type="date"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @change="endTime"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="leaveDayNum"
                  label="销假天数"
                  prop="leaveDayNum"
                >
                  <el-input
                    v-model="form.leaveDayNum"
                    placeholder="请输入销假天数"
                    maxlength="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              class="el-form-item-update"
              ref="leaveReason"
              label="备注"
              prop="leaveReason"
            >
              <el-input
                type="textarea"
                maxlength="150"
                show-word-limit
                :rows="3"
                placeholder="请输入备注"
                v-model="form.leaveReason"
              ></el-input>
            </el-form-item>
					</el-form>
			</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="back">取消</el-button>
        <el-button type="primary" @click="onSubmit">提交申请</el-button>
      </span>
		</el-dialog>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
export default {
	mixins: [minxin],
	components: { drawer },
	data(vm) {
		return {
      form: {
				id: '',
			},
			addEditTitle: '',
			addEditShow: false,
			optionName: [], // 请假人
			allStaffList: [], // 请假类型
			pickerOptions: vm.parent ? vm.parent.$refs.cancelForm.disabledDate() : '',
      beginTime: '',
      endTimes: ''
		}
	},
	created() {
		this.editInit()
	},
	methods: {
		back() {
			this.addEditShow = false
			this.$emit('change', true)
			this.$refs['form'].resetFields()
		},
		editInit() {
			this.$on('set', function(org) {
				Object.assign(this.$data, this.$options.data())
				if (org) {
					this.$api.get(this.$url.companyLeave.get, { id: org.id }).then((res) => {
            if (res) {
              this.form = res;
              this.form.beginTime = this.formatDay(res.beginTime)
              this.form.beginTime1 = this.formatDay(
                res.beginTime);
              this.form.endTime1 = this.formatDay(
                res.endTime);
              this.form.endTime = this.formatDay(res.endTime);
              this.form.leaveReason = '';
            }
          })
					this.addEditShow = true;
				}
			})
		},
		handleChangeDrawer() {
			this.$refs['form'].clearValidate()
			this.addEditShow = false
			this.$emit('change', false)
		},
		startTime(val) {
			// 开始时间
			if (val && this.form.endTime) {
				if (
					new Date(val).getTime() >
					new Date(this.form.endTime).getTime()
				) {
					this.form.leaveDayNum = ''
					return (this.form.endTime = '')
				} else {
					let a = this.datedifference(val, this.form.endTime)
					this.$set(this.form, 'leaveDayNum', a + 1)
				}
			}
		},
		endTime(val) {
			// 结束时间
			if (!this.form.beginTime) {
				this.form.endTime = ''
				return this.$message.error('请先选择开始时间')
			}
			if (val && this.form.beginTime) {
				if (
					new Date(this.form.beginTime).getTime() >
					new Date(val).getTime()
				) {
					this.form.endTime = ''
					this.form.leaveDayNum = ''
					return this.$message.warning('开始时间不能大于结束时间')
				} else {
					let a = this.datedifference(this.form.beginTime, val)
					this.$set(this.form, 'leaveDayNum', a + 1)
				}
			}
		},
    disabledDate () {
      let that = this;
      return {
          disabledDate:time => {
            return !(new Date(that.form.beginTime1).getTime() < time.getTime() + 60*60*24*1000 && time.getTime() < new Date(that.form.endTime1).getTime());
          }
      }
    },
		onSubmit(values) {
			if (!this.form.leaveDayNum) {
				return this.$message.error('请输入销假天数')
			} else if (this.form.leaveDayNum == 0) {
				return this.$message.error('销假天数不能为零')
			} else if (isNaN(this.form.leaveDayNum)) {
				return this.$message.error('销假天数请输入数字类型')
			} else if (!this.form.leaveReason) {
				return this.$message.error('请输入备注')
			}
      this.form.leaveCateId = '2';
      this.form.parentId = this.form.id;
			this.$api
				.post(this.$url.companyLeave.apply, this.form)
				.then((res) => {
					if (res) {
						this.addEditShow = false;
						this.$message.success('操作成功');
						this.$emit('change', true);
					}
				})
				.catch((error) => {})
		},
	},
}
</script>
<style scoped lang="less">
@import '../../../assets/css/edit.less';
/deep/ .el-dialog__body {
  border-top: 1px solid #F5F5F5;
}
.el-form-item-update {
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    margin: 0;
    background: #fff;
    &:first-child {
      margin-top: 0;
    }
    /deep/ .el-form-item__label {
      font-size: 16px;
      font-weight: 500;
    }
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
    /deep/ .el-radio__inner {
      width: 22px;
      height: 22px;
    }
    /deep/ .el-radio__label {
      font-size: 16px;
    }
    /deep/ .el-select {
      width: 100%;
    }
    /deep/ .el-date-editor {
      width: 100%;
    }
  }
</style>
